import css from './IconWithTextWrapper.module.css';

interface IconWithTextWrapperProps {
    icon: React.ReactNode;
    text: string;
}

export const IconWithTextWrapper: React.FC<IconWithTextWrapperProps> = ({
    icon,
    text,
}) => (
    <div className={css.container}>
        <div className={css.icon}> {icon}</div>
        {text}
    </div>
);
